import { Handle, Position, type NodeProps, type Node } from "@xyflow/react";
import LinkHandles from "./LinkHandles";
import styles from "./WorkflowNode.module.css";

interface StageData {
  label: string;
  probability?: string | number;
}

export default function StageNode({ data }: NodeProps<Node>) {
  const d = data as unknown as StageData;
  const pct =
    d.probability !== undefined && d.probability !== ""
      ? `${Math.round(Number(d.probability) * 100)}%`
      : null;
  return (
    <div className={`${styles.card} ${styles.stage}`}>
      <Handle type="target" position={Position.Left} />
      <p className={styles.kind}>Stage</p>
      <p className={styles.label}>{d.label}</p>
      {pct && <p className={styles.subtitle}>{pct}</p>}
      <Handle type="source" position={Position.Right} />
      <LinkHandles />
    </div>
  );
}
